
const codeColors = {
  blue: '#005CC5',
  green: '#22863A',
  black: '#24292E',
  gray: '#6A737D',
  purple: '#6F42C1',
  red: '#D73A49',
  white: '#FBFBFB',
};

export const codeTheme = {
  lineNumberColor: codeColors.black,
  lineNumberBgColor: codeColors.white,
  backgroundColor: codeColors.white,
  textColor: codeColors.black,
  substringColor: codeColors.blue,
  keywordColor: codeColors.red,
  attributeColor: codeColors.purple,
  selectorTagColor: codeColors.purple,
  docTagColor: codeColors.blue,
  nameColor: codeColors.purple,
  builtInColor: codeColors.blue,
  literalColor: codeColors.green,
  bulletColor: codeColors.purple,
  codeColor: codeColors.blue,
  additionColor: codeColors.blue,
  regexpColor: codeColors.blue,
  symbolColor: codeColors.blue,
  variableColor: codeColors.black,
  templateVariableColor: codeColors.green,
  linkColor: codeColors.purple,
  selectorAttributeColor: codeColors.green,
  selectorPseudoColor: codeColors.green,
  typeColor: codeColors.purple,
  stringColor: codeColors.blue,
  selectorIdColor: codeColors.blue,
  selectorClassColor: codeColors.blue,
  quoteColor: codeColors.blue,
  templateTagColor: codeColors.green,
  deletionColor: codeColors.green,
  titleColor: codeColors.red,
  sectionColor: codeColors.black,
  commentColor: codeColors.gray,
  metaKeywordColor: codeColors.blue,
  metaColor: codeColors.blue,
  functionColor: codeColors.red,
  numberColor: codeColors.purple,
};
